import { combineReducers } from 'redux-immutablejs';

import globalReducer from './global';
import marketAreaReducer from './marketArea';
import massUpdateReducer from './massUpdate';
import settingsReducer from './settings';
import comparablesReducer from './comparables';
import strataReducer from './strata';
import stratificationsReducer from './stratifications';

export default combineReducers({
  global: globalReducer,
  marketArea: marketAreaReducer,
  massUpdate: massUpdateReducer,
  settings: settingsReducer,
  comparables: comparablesReducer,
  strata: strataReducer,
  stratifications: stratificationsReducer
});
